import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownProps {
  /** The Worker can return null for PR description / review fields — guard at
   *  the component boundary so callers don't each have to optional-chain. */
  children: string | null | undefined;
  className?: string;
}

/**
 * GitHub-flavored markdown → React elements. Renders no raw HTML, so PR/agent
 * content can't inject scripts (XSS-safe without DOMPurify). Prose styling
 * lives in index.css under `.md-content`, which uses `color: inherit` so each
 * call-site controls the base hue (muted meta vs. full-ink body).
 */
export function Markdown({ children, className = '' }: MarkdownProps) {
  if (typeof children !== 'string') return null;
  return (
    <div className={`md-content ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // External links open safely in a new tab.
          a({ node: _node, ...props }) {
            return <a {...props} target="_blank" rel="noopener noreferrer" />;
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
